// extracted by mini-css-extract-plugin
export default {"container":"TableV2_container__WSnBz","table":"TableV2_table__1VzjW"};